import { useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { Button, Input, TextField } from '@zep/ui';
import { useSingularSubscriptionPaymentMutation } from '../../../../../services';
import { SingularSubscriptionPaymentResponse } from '../../../../../types/PaymentTypes';
import { BusinessPaymentLayout } from '../../../business/BusinessPaymentLayout';
import S from '../../../business/BusinessPayments.module.scss';
export const ConfirmSingularSubscriptionEmail = ({
  businessName,
  paymentHashId,
  onInvalidPage,
  onSetPaymentInfo
}: {
  paymentHashId: string;
  businessName: string;
  onInvalidPage: () => void;
  onSetPaymentInfo: (payment: SingularSubscriptionPaymentResponse) => void;
}) => {
  const {
    t
  } = useTranslation(['common', 'business']);
  const router = useRouter();
  const [error, setError] = useState(false);
  const [email, setEmail] = useState('');
  const {
    mutateAsync
  } = useSingularSubscriptionPaymentMutation();
  const handleCheck = async () => {
    if (!email) {
      return;
    }
    try {
      const data = await mutateAsync({
        email,
        paymentRequestHashId: paymentHashId
      });
      if (data.data.paymentRequest.status === 'DONE') {
        router.push(`/payment/singular/${paymentHashId}/success?email=${encodeURIComponent(email)}`);
        return;
      } else if (data.data.paymentRequest.status === 'CANCELED') {
        onInvalidPage();
        return;
      }
      onSetPaymentInfo(data.data);
    } catch (e) {
      // UI 는 아래 setError 로 처리하고, 원인 추적을 위해 로그는 남긴다.
      logger.captureError(e, {
        tags: {
          feature: 'singular-subscription-email'
        }
      });
      setError(true);
      setEmail('');
    }
  };
  return <BusinessPaymentLayout isCenter={true} title={''} data-sentry-element="BusinessPaymentLayout" data-sentry-component="ConfirmSingularSubscriptionEmail" data-sentry-source-file="ConfirmSingularSubscriptionEmail.tsx">
      <div className={S.checker_wrapper}>
        <h4 className={S.checker_business_name}>{businessName}</h4>
        <div className={S.checker_email_description}>
          {t('business:business_payments_enter_email')}
        </div>
        <TextField error={error} helperText={error && t('business:business_payments_email_invalid')} data-sentry-element="TextField" data-sentry-source-file="ConfirmSingularSubscriptionEmail.tsx">
          <Input value={email} onChange={e => setEmail(e.currentTarget.value)} onKeyDown={e => {
          if (e.key === 'Enter') {
            handleCheck();
          }
        }} placeholder={t('business:business_payments_email_placeholder')} isFullWidth data-sentry-element="Input" data-sentry-source-file="ConfirmSingularSubscriptionEmail.tsx" />
        </TextField>
        <Button className={S.checker_confirm_button} size="lg" isFullWidth onClick={handleCheck} data-sentry-element="Button" data-sentry-source-file="ConfirmSingularSubscriptionEmail.tsx">
          {t('common:confirm')}
        </Button>
      </div>
    </BusinessPaymentLayout>;
};